<template>
  <div>
    <div class="year-picker">
      <pc-text-input
        :value="value"
        :placeholder="placeholder"
        :label="label"
        :mask-options="{
          mask: '0000'
        }"
        :errors="errors"
        class="year-picker__input"
        icon-name="pc-calendar"
        @focusin="inputFocus"
        @input="chooseYear"
        @focusout="setYear"
      />
      <div
        ref="options"
        v-click-outside="hideYearContent"
        :class="{top: showOptionsOnTop, opened: showYearContent}"
        class="year-picker__year-box"
      >
        <div class="year-picker__year-title">
          <span class="to-left" @click="toLeft()">&#60;</span>
          <strong>{{ yearStart }} - {{ yearEnd-1 }}</strong>
          <span class="to-right" @click="toRight()">&#62;</span>
        </div>
        <div class="year-picker__year-content">
          <span
            v-for="(item,index) in yearList"
            :key="index"
            class="year-text"
            :class="{'year-disable':yearDis(item), 'active': item === Number(value)}"
            @click="chooseYear(item, true)"
          >{{ item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PcTextInput from '@/components/inputs/PcTextInput.vue'

export default {
  name: 'YearPicker',
  components: {PcTextInput},
  props: {
    errors: {
      type: Array,
      default: () => {}
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    value: {
      type: [Number , String]
    },

    placeholder:{
        type:String,
        default:''
    },
    label: {
      type:String,
      default: ''
    }
  },
  data() {
    return {
      yearLists: [],
      year: '',
      showYearContent: false,
      yearStart: 2020,
      yearEnd: 2040,
      showOptionsOnTop: false,
      optionsVisibility: false
    }
  },
  computed: {
    yearDis() {
      return function (y) {
        return y > this.max || y < this.min
      }
    },
    yearList() {
      let arr = []
      for (let i = this.yearStart; i < this.yearEnd; i++) {
        arr.push(i)
      }
      return arr
    }
  },

  methods: {
    hideYearContent(e) {
      if( !e.target.classList.contains('input') ) {
        this.showYearContent = false
        this.showOptionsOnTop = false
      }
    },
    inputFocus() {
      this.setOptionsPosition()
      this.showYearContent = true
    },
    chooseYear(year, isPopup) {
      if (isPopup && this.yearDis(Number(year))) return
      this.showYearContent = false
      this.$emit('input', year.toString())
    },
    toLeft() {
      this.yearStart -= 20
      this.yearEnd -= 20
    },
    toRight() {
      this.yearStart += 20
      this.yearEnd += 20
    },
    setOptionsPosition() {
      const optionsTopPos = this.$refs.options.getBoundingClientRect().top
      this.showOptionsOnTop = optionsTopPos + 292 >  window.innerHeight
    },
    setYear() {
      if(Number(this.value) < this.min) {
        this.$emit('input', this.min.toString())
      }
      if(Number(this.value) > this.max) {
        this.$emit('input', this.max.toString())
      }
    }
  }
}
</script>

<style scoped lang="scss">
;
.year-picker {
  position: relative;
  width: 100%;
  .year-picker__icon {
    position: absolute;
    transform: translate(-26px, 10px);
    color: #d9d9d9;
  }

  .year-picker__input {
    border: none;
    /*outline: none;*/
    border-radius: 5px;
    text-indent: 10px;
    /*padding-left: 10px;*/
    line-height: 32px;
  }

  .year-picker__input::placeholder {
    /*color: #d9d9d9;*/
  }

  .year-picker__input--real {
    border: 1px solid #d9d9d9;
    height: 32px;
  }

  .year-picker__input--focus {
    opacity: 0;
    /*border: 1px solid #007af4;*/
    /*width: 267px;*/
    /*height: 30px;*/
  }

  .year-picker__input--real:hover {
    border: 1px solid rgba(0, 122, 244, 0.8);
  }

  .year-picker__year-title {
    height: 40px;
    width: 270px;
    border-top: 1px solid #d4d4d4;
    border-bottom: 1px solid #d4d4d4;
    display: flex;
    justify-content: space-around;
    align-items: center;

    span {
      color: #525252;
      cursor: pointer;
    }

    span:active {
      opacity: 0.5;
    }
  }

  .year-picker__year-box {
    position: absolute;
    top:80px;
    visibility: hidden;
    z-index: -2;
    background: #ffffff;
    border-radius: 5px;
    border: 1px solid #eeeeee;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.3);

    &.opened {
      visibility: visible;
      z-index: 100;
    }
    &.top {
      top: auto;
      bottom: 90px;
    }
  }

  .year-picker__year-content {
    padding-top: 20px;
    width: 270px;
    height: 250px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    .year-text {
      color: #525252;
      font-size: 16px;
      width: 48px;
      height: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .year-text:hover {
      cursor: pointer;
      /*border: 1px solid #333333;*/
      background: rgba(157, 219, 252, 0.41);
      border-radius: 3px;
    }

    .year-disable {
      opacity: 0.4;
    }

    .year-disable:hover {
      cursor: no-drop;
      background: #f5f5f5;
    }

    .active {
      font-weight: bold;
      color: #0c213a;
    }
  }
}

</style>
